module.exports = __webpack_public_path__ + "media/site_templates/www.lawnmowingservices.me/images/our_services_2-915cc3c36dcba6b54d20a44483171840.jpg";